export enum UIMode {
  ZoomAndPan,
  Touch,
  Mouse,
  Drawing,
  Marker,
}
